import React, { FC } from 'react'
import { TabControlProps } from './Tabs.types'

export const TabControl: FC<TabControlProps> = ({ index, handleTabClick, tabLength }) => {
  return (
    <div className='Carousel-toggle u-sizeConstrained u-marginLeftM8 u-flex u-flexAlignItemsEnd u-Mobile u-lg-hidden u-md-hidden u-paddingVert8'>
      <button
        id='carousel-previous'
        aria-hidden='false'
        className='Button Button--secondary Button--secondary--action-blue Button--icon Button--icon--stroke u-marginRight16'
        onClick={() => {
          handleTabClick(index - 1)
        }}
        disabled={index === 0}>
        <span className='adel-material-symbols' aria-hidden='true' role='img'>
          chevron_left
        </span>
        <span className='u-hiddenVisually'>Slide Left</span>
      </button>
      <button
        id='carousel-next'
        aria-hidden='false'
        className='Button Button--secondary Button--secondary--action-blue Button--icon Button--icon--stroke u-marginRight16'
        onClick={() => {
          handleTabClick(index + 1)
        }}
        disabled={index === tabLength - 1}>
        <span className='adel-material-symbols' aria-hidden='true' role='img'>
          chevron_right
        </span>
        <span className='u-hiddenVisually'>Slide Right</span>
      </button>
      <p className='u-textColorActionBlue u-paddingLeft0'>
        {index + 1} / {tabLength}
      </p>
    </div>
  )
}
